import { formatPrice } from '../../helpers/formatPrice';


export default {
  __name: 'AddToCartButton',
  props: {
    price: {
        type: String,
        required: true,
    },
    isSubmitting: {
        type: Boolean,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props;



const __returned__ = { props, get formatPrice() { return formatPrice } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}